import withScorm from './withScorm';
import ScormProvider from './ScormProvider';

export { withScorm };
export default ScormProvider;
